import { withErrorBoundary } from "@sentry/nextjs";
import React, { CSSProperties, FC, ReactNode } from "react";
import styled from "styled-components";
import { Stars } from "icons";

interface Props {
  children: ReactNode;
  color: string;
  backgroundColor: string;
  className: string;
}

const StarsContainer: FC<Props> = withErrorBoundary(({ children, color, backgroundColor, className }) => {
  return (
    <StyledStarsContainer
      color={color}
      style={
        {
          "--color": color,
          "--background-color": backgroundColor,
        } as CSSProperties
      }
      className={className}
    >
      <Stars className="Stars__icon" />
      {children}
    </StyledStarsContainer>
  );
}, {});

const StyledStarsContainer = styled.div`
  color: var(--color);
  display: flex;
  align-items: flex-start;
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--background-color);
  width: fit-content;

  .Stars__icon {
    width: 16px;
    height: 16px;
    fill: var(--color);
    margin-top: 3px;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .Link__icon {
    fill: var(--color);
    width: 16px;
    height: 16px;
  }
`;

export { StarsContainer };
